/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-icons{width:100%;margin-bottom:10px}.input-icons i{position:absolute}.icon{padding:10px;font-size:15px}.input-field{width:100%;padding:10px;text-align:center}.ps-menu-item{min-width:280px}.ps-menu-icon{display:inline-block;width:24px;margin-right:12px;text-align:center;font-size:20px}.ps-menu-divider{margin:4px 0}"];
export { styles as styles };
